
import { ChangeDetectorRef, Component } from '@angular/core';
import { Subscription } from 'rxjs';

import { environment as ENV } from '@environment';
import { isNull } from '@app/util/util';
import { AppFacade } from '@app/app.facade';
import { TranslocoService } from '@jsverse/transloco';
import { CalendarField } from '@shared/base-search-bar/entities/calendar.entities';
import { SearchType } from '@search-bar/entities/search-type';
import { mapCalendarDaysLimit } from '@shared/base-search-bar/mappers/search-bar-calendar.mapper';
import { environment } from '@environment';
import { searchProductTypeMapper } from '@app/modules/core/mappers/amplitude-mappers';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';
import { User, UserInfo, UserLoyaltyType } from '@app/modules/core/interfaces/user';
import { DateCalendarLocale } from '@design-system/components/organisms/date-calendar/entities/date-calendar.types';
import { isByHours } from '@hotels/hotel-search/componenets/byhours-search/mappers/byhours.mapper';

@Component({
  template: '',
  standalone: false
})
export abstract class SearchBarCalendarAbstractComponent {

  public _activeType: CalendarField;
  public translate: number = 0;
  public showCalendar: boolean = false;

  protected calendarMatrixPadding: number = 200;
  protected user: UserInfo = null;
  protected subscriptions: Subscription[] = [];

  constructor(
    protected changeDetectorRef: ChangeDetectorRef,
    protected appFacade: AppFacade,
    protected translateService: TranslocoService,
  ) { }

  get localeByLanguage(): DateCalendarLocale {
    return ENV.language?.toLowerCase() as DateCalendarLocale;
  }

  protected daysBetweenTwoDatesLabelAbstract(days: number, searchType: SearchType): string {
    const producType = searchProductTypeMapper(searchType);
    const defaultlabel = 'CALENDAR.SELECT_CALENDAR';
    const isEmptyValue = days === 0 || isNull(days);
    const isSingularValue = !isEmptyValue && days === 1;
    switch (producType) {
      case SearchBy.BUSES:
      case SearchBy.FLIGHTS:
        return isEmptyValue || isSingularValue ? defaultlabel : 'CALENDAR.SELECT_CALENDAR_TRAVEL_DATES';
      case SearchBy.HOTELS:
      case SearchBy.PACKAGES:
        return isEmptyValue || isSingularValue ? defaultlabel : 'CALENDAR.SELECT_CALENDAR_STAY_DATES';
      default:
        return defaultlabel;
    }
  }

  protected isDiamondUser(user: User): boolean {
    return user?.loyalty?.type === UserLoyaltyType.Diamond;
  }

  public calendarDaysLimit(
    searchType: SearchType, userId: number, isPrime: boolean, isDiamond: boolean, hasRappicard: boolean
  ): number {
    const calendar_days_limit = mapCalendarDaysLimit(searchType)?.calendar_days_limit;
    const calendar_users_days_limit = mapCalendarDaysLimit(searchType)?.calendar_users_days_limit;
    if (this.disabledLimits(isPrime, isDiamond, hasRappicard, isByHours(searchType))) {
      return environment.calendar_users_days_prime;
    }
    if (calendar_users_days_limit && calendar_users_days_limit?.length > 0) {
      const findUser = calendar_users_days_limit.filter(x => x.id === userId);
      if (findUser && findUser.length > 0) {
        return findUser['days'];
      } else {
        return calendar_days_limit;
      }
    } else {
      return calendar_days_limit;
    }
  }

  private disabledLimits(isPrime: boolean, isDiamond: boolean, hasRappicard: boolean, hasByHours: boolean): boolean {
    return !!isPrime || !!isDiamond || !!hasRappicard || hasByHours;
  }
}
